import { useToast } from "hook/useToast";
import React, { useState } from "react";
import { MainPolicySettingBlock, PolicyCustomizeSection, SubPolicySettingBlock } from "uis/Section";
import UI from "@mile-meeting/mile-ui";
import AlertModal from "uis/modal/alert-modal";
import { GLOBAL_MEETING_SETTING_VALUE } from "types/meeting-settings.types";

type NoshowNotificationSettingProps = {
  hasMeetingRoomUsedTablet: boolean;
  noShowEnabled: GLOBAL_MEETING_SETTING_VALUE;
  noShowWarningActive: boolean;
  onChangeNoShowWarningActive: (active: boolean) => void;
  onChangeWarningTime: (time: number) => void;
  onChangeNoshowProcessingAlarmActive: (active: boolean) => void;
  noShowWarningTime: number;
  noShowProcessingActive: boolean;
};
const NoshowNotificationSetting: React.FC<NoshowNotificationSettingProps> = ({
  hasMeetingRoomUsedTablet,
  noShowEnabled,
  noShowWarningActive,
  noShowWarningTime,
  noShowProcessingActive,
  onChangeWarningTime,
  onChangeNoShowWarningActive,
  onChangeNoshowProcessingAlarmActive,
}) => {
  const { showToast } = useToast();
  const [noShowWarningActiveModal, setNoShowWarningActiveModal] = useState<boolean>(false);
  const [noShowWarningUnActiveModal, setNoShowWarningUnActiveModal] = useState<boolean>(false);
  const [noShowProcessingActiveModal, setNoShowProcessingActiveModal] = useState<boolean>(false);
  const [noShowProcessingUnActiveModal, setNoShowProcessingUnActiveModal] = useState<boolean>(false);

  return (
    <PolicyCustomizeSection title="노쇼 알림 설정">
      <MainPolicySettingBlock
        title="노쇼 경고 알림 활성화"
        description="활성화 시 노쇼 예약 취소 전, 참석자에게 취소 처리에 대한 경고 알림을 전송합니다."
        haveChildren={noShowWarningActive}
        rightChildren={
          <div style={{ position: "relative" }}>
            <UI.Selection.Toggle.Default
              size="large"
              state={noShowWarningActive}
              onChange={(enabled) =>
                enabled ? setNoShowWarningActiveModal(true) : setNoShowWarningUnActiveModal(true)
              }
              disabled={!hasMeetingRoomUsedTablet || noShowEnabled === GLOBAL_MEETING_SETTING_VALUE.OFF}
            />
            {(!hasMeetingRoomUsedTablet || noShowEnabled === GLOBAL_MEETING_SETTING_VALUE.OFF) && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                onClick={() => {
                  if (noShowEnabled === GLOBAL_MEETING_SETTING_VALUE.OFF) {
                    showToast(
                      "노쇼 알림은 '노쇼 정책 관리 > 노쇼 취소 기능' 활성화 시에만 사용 가능합니다.",
                      "warning"
                    );
                  }
                }}
              />
            )}
          </div>
        }
      />
      {noShowWarningActive && (
        <SubPolicySettingBlock
          title="노쇼 경고 알림 시간"
          description="예약 시작 시간 기준으로 설정한 시간 후, 참석자에게 회의 시작 요청 알림을 전송합니다."
          rightChildren={
            <UI.SelectBox
              size="small"
              data={["0분", "5분", "10분"]}
              selectedData={[noShowWarningTime + "분"]}
              value={noShowWarningTime + "분"}
              width={120}
              dropdownMaxHeight={120}
              onChange={(time: string[]) => {
                onChangeWarningTime(Number(time[0].replaceAll("분", "")));
              }}
              disabled={!hasMeetingRoomUsedTablet}
            />
          }
        />
      )}
      <MainPolicySettingBlock
        showBorderTop
        title="노쇼 처리 알림 활성화"
        description="활성화 시 예약이 노쇼 처리된 경우, 참석자에게 알림을 전송합니다."
        rightChildren={
          <div style={{ position: "relative" }}>
            <UI.Selection.Toggle.Default
              size="large"
              state={noShowProcessingActive}
              onChange={(enabled) =>
                enabled ? setNoShowProcessingActiveModal(true) : setNoShowProcessingUnActiveModal(true)
              }
              disabled={!hasMeetingRoomUsedTablet || noShowEnabled === GLOBAL_MEETING_SETTING_VALUE.OFF}
            />
            {(!hasMeetingRoomUsedTablet || noShowEnabled === GLOBAL_MEETING_SETTING_VALUE.OFF) && (
              <div
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                onClick={() => {
                  if (noShowEnabled === GLOBAL_MEETING_SETTING_VALUE.OFF) {
                    showToast(
                      "노쇼 알림은 '노쇼 정책 관리 > 노쇼 취소 기능' 활성화 시에만 사용 가능합니다.",
                      "warning"
                    );
                  }
                }}
              />
            )}
          </div>
        }
      />
      <AlertModal
        title="노쇼 경고 알림을 활성화하시겠습니까?"
        content={
          <p style={{ textAlign: "center" }}>
            예약 시작 시간이 지났지만 회의실에 체크인하지 않은
            <br />
            경우, 경고 알림을 전송합니다.
          </p>
        }
        btnTitle="변경하기"
        onChange={() => {
          onChangeNoShowWarningActive(true);
          setNoShowWarningActiveModal(false);
        }}
        modalIsOpen={noShowWarningActiveModal}
        closeModal={() => setNoShowWarningActiveModal(false)}
      />
      <AlertModal
        title="노쇼 경고 알림을 비활성화하시겠습니까?"
        content={<p style={{ textAlign: "center" }}>노쇼 경고 알림을 전송하지 않습니다.</p>}
        btnTitle="변경하기"
        onChange={() => {
          onChangeNoShowWarningActive(false);
          setNoShowWarningUnActiveModal(false);
        }}
        modalIsOpen={noShowWarningUnActiveModal}
        closeModal={() => setNoShowWarningUnActiveModal(false)}
      />
      <AlertModal
        title="노쇼 처리 알림을 활성화하시겠습니까?"
        content={<p style={{ textAlign: "center" }}>예약 노쇼 처리에 대한 알림을 전송합니다.</p>}
        btnTitle="변경하기"
        onChange={() => {
          onChangeNoshowProcessingAlarmActive(true);
          setNoShowProcessingActiveModal(false);
        }}
        modalIsOpen={noShowProcessingActiveModal}
        closeModal={() => setNoShowProcessingActiveModal(false)}
      />
      <AlertModal
        title="노쇼 처리 알림을 비활성화하시겠습니까?"
        content={<p style={{ textAlign: "center" }}>예약 노쇼 처리에 대한 알림을 전송하지 않습니다.</p>}
        btnTitle="변경하기"
        onChange={() => {
          onChangeNoshowProcessingAlarmActive(false);
          setNoShowProcessingUnActiveModal(false);
        }}
        modalIsOpen={noShowProcessingUnActiveModal}
        closeModal={() => setNoShowProcessingUnActiveModal(false)}
      />
    </PolicyCustomizeSection>
  );
};

export default React.memo(NoshowNotificationSetting);
